import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BookMarked, Loader2, Calendar } from "lucide-react";
import { api } from "@/lib/api";
import { TopBar } from "@/components/layout/TopBar";

export default function AbiJournal() {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/abi/copilot/learning/journal")
      .then(r => setEntries(r.data.entries || []))
      .catch(() => toast.error("Erreur de chargement."))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div className="p-8 flex items-center gap-2" data-testid="abi-journal-loading">
      <Loader2 size={16} className="animate-spin" /> Chargement du journal…
    </div>
  );

  return (
    <div className="min-h-screen" style={{ backgroundColor: "#FBF6EA" }}
          data-testid="abi-journal-root">
      <TopBar />
      <div className="px-8 pt-8 pb-6"
            style={{ background: "linear-gradient(120deg,#0B2545 0%,#123B6E 60%,#1D5AA5 100%)" }}>
        <div className="max-w-4xl mx-auto text-ivory">
          <div className="flex items-center gap-2 text-[11px] uppercase tracking-widest opacity-80">
            <BookMarked size={14} /> ALTIORA · Journal d'Apprentissage
          </div>
          <h1 className="text-3xl md:text-4xl font-serif mt-2 leading-tight text-white"
              data-testid="abi-journal-title">
            Voici votre progression, semaine après semaine
          </h1>
          <p className="text-white/85 mt-3 max-w-3xl italic">
            Chaque vendredi, ABI persiste ce qu'il a appris de vous. Faites défiler
            pour revoir votre trajectoire — le mois dernier, il y a 6 mois, il y a un an.
          </p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-8 py-8">
        {entries.length === 0 && (
          <div className="text-center italic text-slate-500 py-8">
            Aucune entrée pour l'instant. Le journal se remplit dès votre premier rituel du vendredi.
          </div>
        )}
        <div className="relative pl-6" style={{ borderLeft: "3px solid #C5A880" }}>
          {entries.map((e, i) => (
            <div key={e.week} data-testid={`abi-journal-entry-${i}`}
                  className="mb-6 relative">
              <div className="absolute w-3 h-3 rounded-full -left-[30px] top-1"
                    style={{ backgroundColor: "#C5A880", boxShadow: "0 0 0 4px #FBF6EA" }} />
              <div className="text-[10px] uppercase tracking-widest font-bold flex items-center gap-1"
                    style={{ color: "#7A5B14" }}>
                <Calendar size={12} /> Semaine {e.week}
                <span className="ml-1 opacity-70">
                  · {e.source === "ai_claude_sonnet_4_5" ? "IA · Claude 4.5" : "Déterministe"}
                </span>
              </div>
              <div className="bg-white rounded-lg shadow-sm p-4 mt-1 space-y-2">
                <div>
                  <span className="text-[10px] uppercase tracking-widest font-bold"
                          style={{ color: "#0B2545" }}>① Ce que j'ai appris de vous · </span>
                  <span className="text-[14px]">{e.narrative.learned_about_you_fr}</span>
                </div>
                <div>
                  <span className="text-[10px] uppercase tracking-widest font-bold"
                          style={{ color: "#7A5B14" }}>② Focus · </span>
                  <span className="text-[14px]">{e.narrative.focus_next_week_fr}</span>
                </div>
                {(e.narrative.corrective_actions_fr || []).length > 0 && (
                  <div>
                    <div className="text-[10px] uppercase tracking-widest font-bold"
                          style={{ color: "#0B7A3B" }}>③ Actions correctives</div>
                    <ul className="text-[13px] mt-0.5 space-y-1">
                      {e.narrative.corrective_actions_fr.map((a, k) => (
                        <li key={k}>· {a}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
